import React from 'react';
import type ProjectSettingsServiceDeskChatSettingsType from '@atlassian/jira-spa-apps-project-settings-service-desk-chat-settings/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskChatSettings = lazyForPaint<
	typeof ProjectSettingsServiceDeskChatSettingsType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-chat-settings", jiraSpaEntry: "async-project-settings-service-desk-chat-settings" */ '@atlassian/jira-spa-apps-project-settings-service-desk-chat-settings'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskChatSettings}
		pageId="project-settings-widget-settings"
		shouldShowSpinner
	/>
);
